import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../../../contexts/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { useAppSelector } from '../../../../hooks/hooks';
import {notebookService} from '../../../../../App';
import './HomeHeader.css';

const HomeHeader = () => {

    //const [currentNotebook, setCurrentNotebook] = useOutletContext();
  
  // @ts-ignore
  const notebook = useSelector((state) => state.notebook.value)
   
  // @ts-ignore
  const notes = useSelector((state) => state.notes.value);

  const navigate = useNavigate();
  const { toggleTheme } = useTheme();

  return (
    <>
    <div className="header">
            <div className="d-flex w-100 justify-content-between">
              <div className="">
                <button
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvas-notebook"
                  aria-controls="offcanvasExample"
                  className="header-btn toggle"
                  title="Open notebooks"
                  onClick={async ()=>{
                    await notebookService.heartbeat();
                  }}
                >
                  <FontAwesomeIcon icon="bars" />
                </button>
                <button
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvas-notes"
                  aria-controls="offcanvasExample"
                  className="header-btn toggle"
                  title={`Notes (${notes.length})`}
                  onClick={async ()=>{
                    await notebookService.heartbeat();
                  }}
                >
                  <FontAwesomeIcon icon="sticky-note" />
                </button>
                <button
                  type="button"
                  className="header-btn"
                  title="Search notes"
                  onClick={async ()=>{
                    await notebookService.heartbeat();
                    navigate("/search");
                  }}
                >
                  <FontAwesomeIcon icon="search" />
                </button>
                <span className='m-1 pointer lt-title d-inline-flex position-relative' onClick={()=>{navigate('/search')}}>
                  <span className='d-none d-lg-block d-xs-none'>Awesome Notes</span></span>
              </div>
              <div className=""></div>
              <div className='d-flex flex-row gap-2'>
                <div className="m-1 align-items-center lt-title">
                  <div>{notebook?.name ?? ""}</div>
                </div>
                <button 
                  type='button'
                  className="header-btn"
                  title='Toggle theme'
                  onClick={() => {
                    toggleTheme();
                  }}
                >
                  <FontAwesomeIcon icon="palette" />
                </button>
                <button 
                  type='button'
                  className="header-btn"
                  title='Settings'
                  onClick={() => {
                    navigate('/settings');
                  }}
                >
                  <FontAwesomeIcon icon="cog" />
                </button>
                <button 
                  type='button'
                  className="header-btn"
                  title='Logout'
                  onClick={()=>{
                    //console.log('logout');
                    navigate("/logout", { replace: true });
                  }}
                >
                  <FontAwesomeIcon icon="sign-out-alt" />
                </button>
              </div>
            </div>
          </div>
    </>
  )
}

export default HomeHeader